import React from 'react';
import style from './ask-panda-button.module.scss';
import { useDispatch } from 'src/store/use-dispatch';
import { setAIChatState } from 'shared/store/actions/ai.actions';
import { setAIV2ChatState } from 'shared/store/actions/ai-v2.actions';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { isPandaV2Enabled } from 'shared/store/selectors/features.selector';
import analyticsService from 'src/helpers/analytics.service';
import { EVENTS } from 'shared/constants';

export function AskPandaButton({ location = 'header' }) {
  const dispatch = useDispatch();
  const lang = useSelector(getLang('AI_CHAT'));
  // Open the chat that will actually render — the switch picks V2 on this flag,
  // and each version tracks its own open state.
  const usePandaV2 = useSelector(isPandaV2Enabled);

  const openAIChat = () => {
    dispatch(usePandaV2 ? setAIV2ChatState(true) : setAIChatState(true));

    analyticsService.track(EVENTS.AI_CHAT.OPEN, {
      location,
    });
  };

  return (
    <button type="button" className={style.root} onClick={openAIChat}>
      {lang.BUTTON_CTA}
    </button>
  );
}
